<template>
  <b-navbar toggleable="lg" type="dark" variant="info" fixed="top" class="shadow-sm">
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-navbar-brand href="#">{{$t('SYSTEM.SITENAME')}}</b-navbar-brand>
    <b-nav class="ml-auto">
      <UserMenu />
    </b-nav>
  </b-navbar>
</template>

<script>
import UserMenu from '@/components/adminparts/UserMenu'

export default {
  components: { UserMenu },
  methods: {
    logoutUser () {
      this.$swal({
        title: this.$t('PAGES.logout.title'),
        text: this.$t('PAGES.logout.swalConf'),
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: this.$t('BUTTON.logout'),
        cancelButtonText: this.$t('BUTTON.cancel'),
        reverseButtons: true
      })
        .then((result) => {
          console.log(result)
          if (result.isConfirmed) {
            this.$store.dispatch('toast/showToast', {
              title: this.$t('PAGES.logout.title'),
              message: this.$t('MESSAGE.logoutSuccess'),
              variant: 'success'
            })
            this.$store.commit('auth/destroy')
            this.$router.push({name: 'Login'})
          } else {
            console.log('cancel')
          }
        })
    }
  }
}
</script>

<style>
.navbar {
  height: 60px;
}
.nav-link {
  color: #d0d0d0;
}
.nav-link:hover {
  color: #ffffff;
}
.dropdown-item {
  font-size: 0.9rem;
}
.dropdown-toggle::after {
    content: none;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/NavigationBar.vue